import React from "react";
import { Link } from "react-router-dom";
import sheLogo from "../../../images/sheLogo.png";

export function NavMenuToggle() {
  setTimeout(() => {
    const mainwrapper = document.querySelector("#main-wrapper");
    if (!mainwrapper) return;
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 0);
}

const NavHader = () => {
  return (
    <div className="qx-nav-header-spacer" aria-hidden="true">
      <Link to="/" className="qx-mobile-logo d-lg-none">
        <img src={sheLogo} alt="She Rents Logo" />
      </Link>
    </div>
  );
};

export default NavHader;
